import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button'
import { Container } from '@/components/generals/container'

export const CtaSection: FC = (): ReactNode => {
    return (
        <section id='get-a-quote' aria-labelledby='get-a-quote-title' className='py-20 sm:py-24'>
            <Container>
                <div className='relative isolate overflow-hidden rounded-[2rem] bg-gold px-6 py-14 sm:px-12 sm:py-16 lg:flex lg:items-center lg:justify-between lg:gap-12 lg:px-16'>
                    <svg
                        aria-hidden='true'
                        focusable='false'
                        viewBox='0 0 64 64'
                        className='pointer-events-none absolute -right-10 -bottom-16 -z-10 size-80 text-gold-foreground/[0.07] sm:size-96'
                    >
                        <path d='M32 20v34' stroke='currentColor' strokeWidth='3' strokeLinecap='round' fill='none' />

                        <g fill='currentColor'>
                            <ellipse cx='32' cy='14.5' rx='3.6' ry='6.2' />
                            <ellipse cx='27' cy='24' rx='3.6' ry='6.2' transform='rotate(-32 27 24)' />
                            <ellipse cx='37' cy='30' rx='3.6' ry='6.2' transform='rotate(32 37 30)' />
                            <ellipse cx='27' cy='36' rx='3.6' ry='6.2' transform='rotate(-32 27 36)' />
                            <ellipse cx='37' cy='42' rx='3.6' ry='6.2' transform='rotate(32 37 42)' />
                        </g>
                    </svg>

                    <div className='max-w-2xl'>
                        <h2
                            id='get-a-quote-title'
                            className='font-heading text-3xl leading-tight font-medium tracking-tight text-gold-foreground sm:text-4xl lg:text-5xl'
                        >
                            Tell us what you need. We&apos;ll come back with a quotation.
                        </h2>

                        <p className='mt-4 text-base leading-relaxed text-gold-foreground/85 sm:text-lg'>
                            Share the variety, quantity and packing. You get a clear quote with specification, delivery terms and price validity.
                        </p>
                    </div>

                    <div className='mt-8 flex shrink-0 flex-col gap-3 sm:flex-row lg:mt-0'>
                        <Link href='/contact' className={buttonVariants({ size: 'lg' })}>
                            Request a quote
                            <ArrowRight aria-hidden='true' />
                        </Link>

                        <Link
                            href='/products'
                            className={cn(
                                buttonVariants({ variant: 'outline', size: 'lg' }),
                                'border-gold-foreground/30 bg-transparent text-gold-foreground hover:bg-gold-foreground/10'
                            )}
                        >
                            View rice varieties
                        </Link>
                    </div>
                </div>
            </Container>
        </section>
    )
}
